import {
  mdiAccountMultiple,
  mdiBroadcast,
  mdiCartOutline,
  mdiEyeOutline,
  mdiImageMultipleOutline,
  mdiPlayCircle,
  mdiPostOutline,
  mdiTagTextOutline,
} from '@mdi/js'
import { POST_TYPE_LIVESTREAM_ANY, POST_TYPES } from '@/constants/post.js'

export const POST_TYPE_FILTER_OVERRIDE = {
  iconPath: mdiPostOutline,
  label: 'Type',
}
export const POST_TYPE_FILTER_COMBOBOX = [
  {
    label: 'Any',
    noValue: true,
    value: '',
  },
  {
    iconPath: mdiPlayCircle,
    label: 'Video',
    value: POST_TYPES.VIDEO,
  },
  {
    iconPath: mdiImageMultipleOutline,
    label: 'Image',
    value: POST_TYPES.IMAGE,
  },
  {
    iconPath: mdiAccountMultiple,
    label: 'Meeting',
    value: POST_TYPES.MEETING,
  },
  {
    iconPath: mdiBroadcast,
    label: 'Livestream',
    value: POST_TYPE_LIVESTREAM_ANY,
  },
]

export const POST_CATEGORY_FILTER_OVERRIDE = {
  iconPath: mdiTagTextOutline,
  label: 'Category',
}
export const POST_CATEGORY_FILTER_COMBOBOX_DEFAULT_ITEM = {
  label: 'Any',
  noValue: true,
  value: '-1',
}

export const POST_PUBLISHED_FILTER_STATE = 'published'
export const POST_UNPUBLISHED_FILTER_STATE = 'unpublished'
export const POST_PUBLISHED_FILTER_OVERRIDE = {
  iconPath: mdiEyeOutline,
  label: 'Status',
}
export const POST_PUBLISHED_FILTER_COMBOBOX = [
  {
    label: 'Any',
    noValue: true,
    value: '',
  },
  {
    label: 'Published',
    value: POST_PUBLISHED_FILTER_STATE,
  },
  {
    label: 'Unpublished',
    value: POST_UNPUBLISHED_FILTER_STATE,
  },
]

export const POST_PURCHASED_FILTER_STATE = 'purchased'
export const POST_NOT_PURCHASED_FILTER_STATE = 'not-purchased'
export const POST_PURCHASED_FILTER_OVERRIDE = {
  iconPath: mdiCartOutline,
  label: 'Status',
}
export const POST_PURCHASED_FILTER_COMBOBOX = [
  {
    label: 'Any',
    noValue: true,
    value: '',
  },
  {
    label: 'Purchased',
    value: POST_PURCHASED_FILTER_STATE,
  },
  {
    label: 'Not purchased',
    value: POST_NOT_PURCHASED_FILTER_STATE,
  },
]
